import React from 'react';
import { View, TouchableOpacity, StyleSheet, Dimensions, SafeAreaView, ActivityIndicator, Animated, StatusBar, PanResponder, Image } from 'react-native';
// import Video from 'react-native-video';
// import BackHandler from './../AndroidBackHandler';
import { withRouter } from 'react-router-dom';
// import Pdf from 'react-native-pdf';
// import { WebView } from 'react-native-webview';
import { Text, Styles } from "./../../components/UI-Components" 
// import OfflineHandler from './../OfflineHandler';
import VideoPlayer from './jwPlayer';
import TextField from '@material-ui/core/TextField';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import ZoomIn from '@material-ui/icons/ZoomIn';
import MenuItem from '@material-ui/core/MenuItem';
// import {addNotes, clearAddNotesData} from './../../store/actions';
import Snackbar from '@material-ui/core/Snackbar';
import ReactDOM from 'react-dom';
import  PDFViewer from 'mgr-pdf-viewer-react';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
// import ReactPlayer from 'react-player';
import { getGetHtmlContent, dispatchClearGetHtmlContent,getGetJwPlayerSourceFiles,
  clearGetJwPlayerSourceFiles,  getBookMarks, addBookMark, clearAddBookMarkData, deleteBookMark } from "./../../store/action";
import { Surface } from 'react-native-paper';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
// import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Fade from '@material-ui/core/Fade';
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import Share from "@material-ui/icons/Share";
import MaterialTest from './materialTestDetails';
import { bookmarksSelector } from './../../store/selectors';
import LiveJWPlayerContainer from './liveJwPlayerComponent';
import { VIDEO, PDF, MATERIAL, EPUB, SHOW_CONTENT_SCREEN } from './../../store/constants/bookmarkConstants';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Container from '@material-ui/core/Container';
import { Document,pdfjs, Page } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const shareIcon = require('./../../assets/assets_png/share.png')
const bookMark = require('./../../assets/assets_png/bookMark.png')
const bookMarked = require('./../../assets/assets_png/bookmarked.png')
const backButtonPrimaryColor = require('./../../assets/assets_png/backButtonPrimaryColor.png')
const isBookmarked = null;

const _width = window.innerWidth;

 
function Transition(props) {
    const  Anime = _width <= 479 ? <Fade in={true} {...props} />  : <Slide direction="up" {...props} /> 
    return Anime;
  }
// const videoHeight = deviceWidth * 0.56;
const CustomPrevButton = (props) => {
    const {
      page,
      pages,
      handlePrevClick
    } = props;
    if (page === 1) return <div></div>;
  
    return <h3 style={{cursor: 'pointer', display: 'inline-block', marginRight: 24, marginTop: 0, color:'#000'}} onClick={handlePrevClick}>Previous page</h3>;
  };
  
  
  const CustomNextButton = (props) => {
    const {
      page,
      pages,
      handleNextClick
    } = props;
    if (page === pages) return <div></div>;
  
    return <h3 style={{cursor: 'pointer', display: 'inline-block', marginLeft: 24, marginTop: 0, color:'#000'}} onClick={handleNextClick}>Next page</h3>;
  };
  
  
   const CustomPages = (props) => {
    const {
      page,
      pages
    } = props;
    return <h3 style={{display: 'inline-block', marginTop: 0, color:'#000'}}>Page {page} from {pages}</h3>;
  };
// const LoadingComponent = ({value}) => (
//     <View>
//         <ActivityIndicator />
//         {/* <Animated.View  
//                 style={[  
//                     styles.inner,{width: value},  
//                 ]}  
//             />   */}
//             {/* <View
//              style={styles.percentageLoader}
//             >
//             <Animated.Text style={styles.label}>  
//                     {value} <Text style={{fontSize: 10}}>%</Text>
//             </Animated.Text>  
//             </View> */}
//     </View>
// )

// const AnimatedHeaderComponent = ({title, onPress, style, headerStyle, ...props}) => (
//     <Animated.View
//         style={[styles.animatedHeader, {...style}]}
//         {...props}
//     >
//         <Surface style={[styles.headerWrapper, headerStyle]}>
//             <View style={styles.headerTitleWrapper}>
//                 <Text 
//                    ellipsizeMode="tail"
//                    numberOfLines={2}
//                     style={styles.headerTitle}
//                 >
//                     {title || 'Title'}
//                 </Text>
//             </View>
//             <TouchableOpacity
//                 onPress={onPress}
//             >
//                 <Icon name="ios-close-circle-outline" size={28} color={Styles.primaryColor}/>
//             </TouchableOpacity>
//         </Surface>
//     </Animated.View>
// )

class ShowEventScreen extends React.Component{

  
     

    state = {
        video: false,
        pdf: false, 
        epub: false,
        value: 0,
        showHeader: true,
        epubLoading: true,
        noInternet: false,
        scale: 1
    }

  

    // componentWillMount() {
    //     this.panResponder = PanResponder.create({
    //         onStartShouldSetPanResponder: () => true,
    //         onMoveShouldSetPanResponder: () => true,
    //         onPanResponderMove: () => {
    //             Animated.event([
    //                 null,
    //                 {dy: this.state.pan.y, dx: this.state.pan.x}
    //             ])
    //         },
    //         onPanResponderRelease: (e, gestureState) => {               
    //             if(gestureState.dy < 1) {
    //                 this.hideHeader();
    //             }else {
    //                 this.showHeader();
    //             }
                
    //         }
    //     })
    // }

    componentDidMount() {
    
        const {
             contentUrl,
            contentType,
            html_content,
            title,
            id,
            subjectId,
            examId,
            topicId,
            formLibrary,
            videoType,
            mentor_name,
            isUrlTrue
        } = this.props.contentData || {};
          const contentId = id;
          // this.props.getBookMarks();
          if(!html_content &&  (contentType === 'epub' || contentType === 'test')){
            this.props.getGetHtmlContent({subjectId, examId, topicId, contentId}, formLibrary);
            if(contentType === 'test') {                            
              this.setState({
                  test: true
              })               
          }

         }

        if ((contentUrl || html_content)&& contentType) {                       

            if(contentType === 'pdf') {
                this.setState({
                    pdf: true,
                    contentUrl: contentUrl
                })
            }

            if(contentType === 'video' && videoType !== 1 && videoType !== '1') {
                this.setState({
                    video: true,
                    contentUrl: contentUrl,
                    videoType
                })
            }

            if(contentType === 'epub' || contentType === 'html') {
                 if(!html_content) {
                    
                 } else{
                     this.setState({
                         epub: true,
                         contentUrl: html_content
                     })
                 }
            }

        }  
        const _contentType = contentType === EPUB ? MATERIAL : contentType; 
        this.isBookmarked(contentId, _contentType);  
       
        if((videoType === 1 || videoType === '1') && contentType === 'video' && !isUrlTrue){          
          // this.props.getGetJwPlayerSourceFiles(contentUrl)
        
        } 
        
        if(contentType === 'live') {
         this.setState({
             live: true,
             contentUrl: contentUrl
         })
     }
        if(contentType === "media_id") {
         this.setState({
             video: true,
             contentUrl: contentUrl
         })
     }
    }

    componentDidUpdate(prevProps){
        if(prevProps.htmlContent !== this.props.htmlContent){
            if(this.props.htmlContent){
                this.setState({
                    epub: true
                })
            }
        }
        if(prevProps.addBookMarkResponse !== this.props.addBookMarkResponse) {
          if(this.props.addBookMarkResponse) {
              this.props.getBookMarks();
          }
      }
      if(prevProps.bookmarkInfo !== this.props.bookmarkInfo) {
        if(this.props.bookmarkInfo) {
          const {
           contentType,
           id,
          
       } = this.props.contentData || {};
       // console.log(this.props.contentData, "Asdlasd")
         const contentId = id;
            this.isBookmarked(contentId, contentType) 
        }
      }
      if(prevProps.jwPlayerPlaylist !== this.props.jwPlayerPlaylist){
        if(this.props.jwPlayerPlaylist){
           console.log(this.props.jwPlayerPlaylist);
            const { videoType, contentUrl } = this.props.contentData;
           
            this.setState({
                videoType,
                video: true,
                contentUrl

            })
        }
    }
    if(prevProps.vimeoError !== this.props.vimeoError) {            
      if(this.props.vimeoError) {
          this.setState({
              videoError: true
          })
       }
     }

    }

    addBookMarks = () => {
        const {
          contentUrl,
          contentType,
          html_content,
          title,
          id,
          subjectId,
          examId,
          topicId,
          formLibrary,
          videoType
        } = this.props.contentData || {};
        const _contentType = contentType === EPUB ? MATERIAL : contentType; 
        const materialData = { contentUrl,
        contentType,
        html_content,
        title,
        id,
        subjectId,
        examId,
        topicId,
        formLibrary,videoType}
          if(this.props.addBookMarkLoading) return; 
               
          const data = {
              content_id: id,
              content_name: 'contentId',
              content_url: contentUrl || "null",
              screen_name: SHOW_CONTENT_SCREEN,
              type: _contentType,
              image_url: null,
              description: null,
              title: title,
              meta_data: JSON.stringify(materialData)
          }
          this.props.addBookMark(data)            
    }

    isBookmarked = (id, contentType) => {
   
      const {bookmarkInfo = {}} = this.props;
      let _contentType = contentType;
      if(contentType === EPUB) _contentType = MATERIAL;
      const { ids ={}, bookmarks=[] } = bookmarkInfo?.[_contentType] || {}
      const bookmarkId = bookmarks.find(b => b.content_id === id);      
      const _isBookmarked = ids[id];
      if(_isBookmarked) {
          // this.props.navigation.setParams({isBookmarked: true, bookmarkId: bookmarkId?.id})
          this.setState({
              isBookmarked: true,
              bookmarkId: bookmarkId?.id
          })
      }else {
          // this.props.navigation.setParams({isBookmarked: false, bookmarkId: bookmarkId?.id})
          this.setState({
              isBookmarked: false,
              bookmarkId: bookmarkId?.id
          })
      }

  }

    componentWillUnmount() {
        
    }

    scaleIncrease = () => {
     
      this.setState({
        scale:this.state.scale + 0.5
      }, () => console.log(this.state.scale))
    }

    scaleDecrease = () => {
      this.setState({
        scale:this.state.scale - 0.5
      })
    }
  

    onBuffer = e => {
        console.log(e, 'on buffer');
    }
    
    onError = e => {
        console.log(e, 'on Error');
    }

    // showHeader = () => {

    //     Animated.parallel([
    //         Animated.timing(this.state.slideDown, {
    //             toValue: 60,
    //             duration: 300,
    //             // useNativeDriver: true
    //         }).start(),
    //         Animated.timing(this.state.scaleY, {
    //             toValue: 1,
    //             duration: 250,
    //             // useNativeDriver: true
    //         }).start()
    //     ])
       
    // }

    // checkInternet = (noInternet) => {
    //     this.setState({
    //         noInternet
    //     })
    // }

    // hideHeader = () => {
    //     Animated.parallel([
    //         Animated.timing(this.state.slideDown, {
    //             toValue: 0,
    //             duration: 300,
    //             // useNativeDriver: true
    //         }).start(),
    //         Animated.timing(this.state.scaleY, {
    //             toValue: 0,
    //             duration: 290,
    //             // useNativeDriver: true
    //         }).start()
    //     ])        
    // }

    loadProgress = (progress) => {
        const value = Math.floor(progress * 100);
        // console.log(value);
        this.setState({
            value
        })
    }

    // goBack = () => this.props.navigation.goBack();

    render() {
        const {  video, pdf, live, epub, isBookmarked } = this.state;
        
        const {
          contentUrl, 
          videoType,
          contentType,
          html_content,
          formLibrary,
          mentor_name,
          facultyInfo = {},
          isUrlTrue,
          title,
          id,
          subjectId,
          examId,
          topicId,
          description,
        
     } = this.props.contentData || {};
        return (
          <div id="dialog" style={{backgroundColor: Styles.primaryColor}}>
          {
            this.props.loading && 
              <View style={{flex: 1, justifyContent: 'center', height: 'center', backgroundColor: 'transparent', height: '100%'}}>
                <ActivityIndicator/>
              </View>
          }
              {
                this.state.videoError && 
                <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <Text style={{color: 'rgba(0,0,0,0.7)', fontWeight: '600'}}>
                        Video not found Please try again later...
                    </Text>
                </View>
            }

          
        <Dialog
          fullScreen
          open={this.props.open}
          onClose={this.props.handleClose}
          // TransitionComponent={Transition}
          style={{marginTop: 0, zIndex:99999,}}
        >
          <div style={{background: '#ecf2f7', width: '100%', height: '100%'}}> 
          <Container maxHeight="lg">
        {/* <div className="notes">
    
        <div className=" notes_btn text-white"
         style={{backgroundColor:primaryColor}} 
        onClick={this.toggleDrawer('right', true)}
        
        >Notes</div>
        <SwipeableDrawer
          className="right_side_drawer"
          anchor="right"
          open={this.state.right}
          onClose={this.toggleDrawer('right', false)}
          onOpen={this.toggleDrawer('right', true)}
        >
          <div
          className="right_side_drawer"
            tabIndex={0}
            role="button"
            // onClick={this.toggleDrawer('right', false)}
            // onKeyDown={this.toggleDrawer('right', false)}
          >
            {sideList}
          </div>
        </SwipeableDrawer>     
        </div> */}
          <List style={{display: 'block', padding: 0}}>
            <ListItem button style={{display: 'flex', justifyContent:'space-between', alignItems:'center',height: 50,
                backgroundColor: "transparent",
                color: '#fff',
                padding: 0,
                fontSize: 16,
                fontWeight:400}} disableRipple>
                <TouchableOpacity
                      hitSlop={{
                          top: 8,
                          bottom: 8,
                          left: 8,
                          right: 8
                      }}
                      onPress={this.props.handleClose} 
                     //  style={[styles.backButton, {position: 'absolute', bottom: 10, right: 10}]}
                      >
                      
                      <Image 
                      source={backButtonPrimaryColor}
                      style={{width: 56 ,height: 56}}
                      />
                  </TouchableOpacity> 
           
            <div style={{display: contentType === 'video' ? 'none' : 'flex', flexDirection: 'row', 
               marginRight:10,justifyContent: 'center', alignItems: 'center', }}>
                   <div
                        // hitSlop={{
                        //     top: 8,
                        //     bottom: 8,
                        //     left: 8,
                        //     right: 8
                        // }}
                        onClick={() => {
                          if(isBookmarked){                                                                                              
                              deleteBookMark(this.state.bookmarkId);
                          }
                          if(!isBookmarked && !this.props.addBookMarkLoading){
                              
                              this.addBookMarks()
                          }
                        }}
                  //  onPress={() => {                                                               
                  //      if(isBookmarked){                                                                                              
                  //          deleteBookMark(this.state.bookmarkId);
                  //      }
                  //      if(!isBookmarked && !this.props.addBookMarkLoading){
                           
                  //          console.log(this.addBookmarks(), "sd")
                  //      }
                  //  }}
                  //  style={[styles.backButton, {position: 'absolute', top: 10, right: 10}]}
               >
                    <Image 
                    source={isBookmarked ? bookMarked  :  bookMark}
                     style={{width: 56 ,height: 56}}
                   />
               </div>
                 <TouchableOpacity
                       hitSlop={{
                           top: 8,
                           bottom: 8,
                           left: 8,
                           right: 8
                       }}
                      //  onPress={share} 
                      //  style={[styles.backButton, {position: 'absolute', bottom: 10, right: 10}]}
                       >
                       
                       <Image 
                       source={shareIcon}
                       style={{width: 56 ,height: 56}}
                       />
                   </TouchableOpacity> 
              </div>
              {/* <div className="pt-1">
                {this.props.contentHeader}                  
              </div> */}
              {/* <div style={{display: 'flex', justifyContent:'center', alignItems:'center',
                height: 50,
                backgroundColor:'blue',
                color: '#fff',
                paddingTop:11,
                fontSize: 16,
                fontWeight:400
            }}>             
              
                 
                  <MultipleContentSelectComponent allContentData={this.props.allContentData} data={this.props.data} content={this.state.content} textField={classes.textField} handleChange={this.handleChange}/>
                
              </div> */}
            </ListItem>
          </List>      
            <div style={{ height: 'calc(100vh - 56px)', overflowY: 'auto', overflowX: 'hidden'}} className='main-component content-component'>
               
              {
                      this.state.video && !this.props.sourceVideoLoading
                      ? (
                       <div style={{justifyContent: 'center'}}>
                        <div style={{maxWidth: '900px', maxHeight: '680px', margin: 'auto', alignSelf: 'center'}}>
                          
                          {
                           
                            !this.props.sourceVideoLoading &&
                              <VideoPlayer
                                contentUrl={contentUrl}
                                isPlayerError={this.isPlayerError}                 
                                url={this.state,contentUrl}                           
                                formLibrary={formLibrary} 
                                mentor_name={mentor_name}                        
                                jwPlayerPlaylist={this.props.jwPlayerPlaylist}
                                isJwPlayer={true}
                                isMediaId={contentType === 'media_id' ? true : false} 
                                // showToaster={this.showToaster}
                                facultyInfo={facultyInfo} 
                                isUrlTrue={isUrlTrue}
                              />
                          }

                        </div>
                          <div style={{maxWidth: 900, alignSelf:'center', margin: 'auto', display: this.props.formLibrary ? 'none' : 'block'}}>
                            <div style={{display: 'flex', justifyContent:'space-between', alignItems: 'center', marginTop: 18, marginBottom: 18}}>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                  <Avatar alt={facultyInfo.facultyFirstName || 'F'} src={facultyInfo.facultyAvatar} />
                                  <div style={{marginLeft: 12}}>
                                    <span style={{fontSize: 16, fontWeight: '700',}}>
                                      {facultyInfo.facultyFirstName}
                                    </span>
                                    <Typography variant="caption" display="block" style={{color: 'rgba(0,0,0,0.65)'}}>
                                    10 years
                                    </Typography>
                                  </div> 
                                 
                                </div>
                                <div style={{display:'flex', flexDirection:'row', alignItems:'center', marginTop: 8}}>
                                {
               
               <div
                  //  hitSlop={{
                  //      top: 8,
                  //      bottom: 8,
                  //      left: 8,
                  //      right: 8
                  //  }}
                   onClick={() => {
                    if(isBookmarked){                                                                                              
                        deleteBookMark(this.state.bookmarkId);
                    }
                    if(!isBookmarked && !this.props.addBookMarkLoading){
                        
                        this.addBookMarks()
                    }
                  }}
                  //  onPress={() => {                                                               
                  //      if(isBookmarked){                                                                                              
                  //          deleteBookMark(bookmarkId);
                  //      }
                  //      if(!isBookmarked && !addBookMarkLoading){
                           
                  //          addBookmark()
                  //      }
                  //  }}
                  //  style={[styles.backButton, {position: 'absolute', top: 10, right: 10}]}
               >
                    <Image 
                    source={isBookmarked ? bookMarked  :  bookMark}
                     style={{width: 56 ,height: 56}}
                   />
               </div>
               }
                   <TouchableOpacity
                       hitSlop={{
                           top: 8,
                           bottom: 8,
                           left: 8,
                           right: 8
                       }}
                      //  onPress={share} 
                      //  style={[styles.backButton, {position: 'absolute', bottom: 10, right: 10}]}
                       >
                       
                       <Image 
                       source={shareIcon}
                       style={{width: 56 ,height: 56}}
                       />
                   </TouchableOpacity>  
                                </div>

                              </div>
                              <Divider style={{margin: '12, 0'}} />
                              <div>
                                <h3>Free Video Tutorials</h3>
                                <p style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}>
                                  {
                                    description
                                  }
                                </p>
                              </div>
                          </div>
                        </div>
                                        
                      ) :
                         contentType === 'live' && this.state.live && contentUrl
                      ?
                       (
                        // <JwPlayer 
                        //   url={this.props.contentData}
                        //   // youtubeConfig={{ playerVars: { showinfo: 1 } }}
                        //   className="react_video"
                        //   config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                        //   controls= {true}
                        //   playing
                        //   playsinline={true}
                        //   onEnded={() => this.autoPlayNextVideo()}
                        //   onProgress={(data) => {
                        //     this.setState({
                        //       videoPlayedSeconds: data.playedSeconds
                        //     })
                        //   }}
                        // />
                        <div style={{maxWidth: '800px', maxHeight: '600px', margin: 'auto', alignSelf: 'center'}}>
                          
                          {
                            this.state.live && 
                              <LiveJWPlayerContainer
                                handleClose={this.props.handleClose}
                                channelId={contentUrl}
                                mentor_name={mentor_name}
                                formLibrary={formLibrary} 
                                goBack={this.goBack} 
                                showToaster={this.showToaster}
                                facultyInfo={facultyInfo}
                              />
                          }

                        </div>
                                        
                      )
                      
                      : contentType ==="pdf" 
                      ? (                      
                        <div style={{height: 'calc(100vh - 60px)',backgroundColor: "transparent"}}> 
                          {/* <div className="p-1" style={{display:'flex', justifyContent:'center', alignItems:'center', position:'fixed', width:'100%', top:"9%"}}>
                              <div style={{width:300, height:40, backgroundColor:'#323643', display:'flex', justifyContent:'center'}}>
                              <Remove  className="ml-2 mt-1" onClick={this.scaleDecrease}  style={{color:'#fff', width:32, height:32}}/>
                              0
                              <ZoomIn className="p-1 ml-2 mt-1" style={{color:'#fff', width:32, height:32}}/>
                              <Add className="mt-1" onClick={this.scaleIncrease} style={{color:'#fff', width:32, height:32}}/>
                             
                              </div>  
                            
                          </div>   */}
                          {/* <div  style={{marginTop: 10,}}> */}
                              {/* <PDFViewer 
                              document={{
                                fileType:'pdf',
                                url: contentUrl,   
                                
                                } 

                              }
                                scale={this.state.scale}
                                css="customViewer"
                                navigation={{
                                  elements: {
                                    previousPageBtn: CustomPrevButton,
                                    nextPageBtn: CustomNextButton,
                                    pages: CustomPages
                                  }
                                }}

                              
                              /> */}
                              {/* <PDFViewer document={{
                                url: 'https://arxiv.org/pdf/quant-ph/0410100.pdf'
                              }} /> */}
                              <iframe 
                              disableprint={true}
                              controlsList="nodownload" style={{width: '100%', height: '100%', border:'1px solid' }} src={contentUrl}/>

                                   {/* <Document
                                // file={'https://storage.googleapis.com/fivemantra.appspot.com/images/4HK0CzUn5Fm7n3QOATdD66wTLPFawIEPojgpl8CM.pdf'}
                                  file = {
                                    // { url: 'https://storage.googleapis.com/fivemantra.appspot.com/images/4HK0CzUn5Fm7n3QOATdD66wTLPFawIEPojgpl8CM.pdf', httpHeaders: { 'Access-Control-Allow-Origin': '*' }}
                                    { url: 'https://storage.googleapis.com/fivemantra.appspot.com/images/4HK0CzUn5Fm7n3QOATdD66wTLPFawIEPojgpl8CM.pdf'}
                                  }
                                      onLoadSuccess={(x) => console.log(x) }
                              >
                                <Page pageNumber={1} />
                              </Document> */}
                          {/* </div> */}

                      </div>
                      
                      )
                      
                     : contentType ==="epub" ?
                       ( 
                      
                         <div style={{padding: 5}}>
     
                         
                            <div style={{backgroundColor: '#d4e4f0', textAlign: 'center', margin: 'auto', width: '100%', height: 32, display: 'flex', alignItems: 'center', justifyContent:'center'}}>
                                <h4 style={{color: '#0069b2', fontSize: 17, textTransform: 'uppercase'}}>Title</h4>
                            </div>
                            {
                                this.props.loading && 
                                  <View style={{width: '100%',justifyContent: 'center', alignItems: 'center', backgroundColor: 'transparent', height: '100%'}}>
                                    <ActivityIndicator/>
                                  </View>
                            }
                              {/* {
                                !this.props.loading && !(this.props.htmlContent && this.props.htmlContent.html_content) &&
                                <div dangerouslySetInnerHTML={{__html: 'NOT FOUND'}} style={{padding: 5, userSelect :' none'}}>
                                </div>
                             } */}
                         
                            {
                              !this.props.loading 
                              &&
                              <div dangerouslySetInnerHTML={{__html: this.props.htmlContent && this.props.htmlContent.html_content || this.state.contentUrl || 'NOT FOUND'}} style={{padding: 5, userSelect :' none'}}>
                              </div>
                              
                            
                            }
           
                         </div>
                       )
                       
                      //  : contentType === 'ppt' ? 
                      //     (
                      //       <div style={{height: 'calc(100vh - 60px)',backgroundColor: "transparent"}}>
                      //       <iframe 
                      //       disableprint={true}
                      //       controlsList="nodownload" 
                      //       toolba={0}
                      //       style={{width: '100%', height: '100%', border:'1px solid' }} 
                      //       src={contentUrl || 'https://products.aspose.app/slides/storage/view/?folder=ccdde55d-9a14-4af3-b52f-0d980700b325&fileName=samplepptx.pptx'}/>
                      //       </div>
                      //     )
                       : null 
                       
                       
                      }
              {
                this.state.test && this.props.htmlContent && Object.keys(this.props.htmlContent).length> 0 &&
                <View style={{flex: 1, height: '100%', width: '100%'}}>
                        <MaterialTest navigation={this.props.history} 
                            data={this.props.htmlContent}
                            />
                    </View>
                } 
          </div>    
                </Container>
                </div>
        </Dialog>
        </div>
        )
    }
}
const mapStatesToProps = state => {
    console.log(state);
    const bookmarkInfo = bookmarksSelector(state.allBookMarks);   

    const htmlContent = state.getHtmlContentInfo && state.getHtmlContentInfo.response 
                       && (state.getHtmlContentInfo.response.material || state.getHtmlContentInfo.response.library_content);

    const loading =  state.getHtmlContentInfo && state.getHtmlContentInfo.loading;                  
    const error =  state.getHtmlContentInfo && state.getHtmlContentInfo.error;        
    const jwPlayerPlaylist =  state.JwPlayerSourceInfo && state.JwPlayerSourceInfo.response
                         && state.JwPlayerSourceInfo.response.playlist[0];
const sourceVideoLoading =  state.JwPlayerSourceInfo && state.JwPlayerSourceInfo.loading          
    return {
        htmlContent,
        loading,
        error,
        // sourceVideoFileInfo,
        sourceVideoLoading,
        jwPlayerPlaylist,
        bookmarkInfo,
        materialBookmarks: bookmarkInfo?.material,
        pdfBookmarks: bookmarkInfo?.pdf,
        videoBookmarks: bookmarkInfo?.video,
        addBookMarkResponse: state?.addBookMark?.response?.bookmark,
        addBookMarkLoading: state?.addBookMark?.loading,
    }
}

export default connect(mapStatesToProps, {getGetHtmlContent, 
  dispatchClearGetHtmlContent, getGetJwPlayerSourceFiles, clearGetJwPlayerSourceFiles,
  getBookMarks, addBookMark, clearAddBookMarkData, deleteBookMark
})(withRouter(ShowEventScreen));

const styles = StyleSheet.create({
    backgroundVideo: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex:8888
    },
    pdf: {
        flex:1,
        width:Dimensions.get('window').width,
    },
    pdfWrapper: {
        position: 'relative',       
        flex: 1,
        // width: deviceWidth
        width: '100%'
    },
    animatedHeader: {
        // width: deviceWidth,
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,      
        // borderWidth: 2,
        // height: 60,
        backgroundColor: '#fff',
        zIndex: 100,
        // backgroundColor: 'red'
    },
    headerWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 12,
        // paddingVertical: 16,
        elevation: 8,
        height: '100%',
        width: '100%'
    },
    headerTitleWrapper: {
        // borderWidth: 1,
        flex: 1
    },
    headerTitle: {
        fontSize: 18,
    },
    videoWrapper: {
        // height: videoHeight,
        // width: deviceWidth,
        // borderWidth: 2
    },
    percentageLoader:{
        borderWidth: 2,
         borderRadius: 50, 
         width: 64,
          height: 64, 
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: Styles.successColor

    },
    // inner:{  
    //     width: "100%",  
    //     height: 30,  
    //     borderRadius: 15,  
    //     backgroundColor:"green",  
    //   },  
      label:{  
        fontSize:18,  
        color: "black",  
        position: "absolute",  
        zIndex: 1,  
        alignSelf: "center",  
      }
})



// import X from './animate'
